import { useBase } from "../base/state.js";
import { useProgression } from "../base/progression-state.js";
import { resetCatalogueCache, useStore } from "../store/state.js";
import { useEvents, claimableCount } from "../events/state.js";
import { useSocial } from "../social/state.js";
import { useUnits } from "../units/state.js";
import { useWorld } from "../world/state.js";
import { useBalances } from "./balances.js";
import type { MeState } from "./session.js";

/** Clear every private cache before another account can render. Local user preferences stay server-owned. */
export function resetDomains(): void {
  resetCatalogueCache();
  useProgression.getState().reset(null);
  useBase.setState(useBase.getInitialState(), true);
  useStore.setState(useStore.getInitialState(), true);
  useEvents.setState(useEvents.getInitialState(), true);
  useSocial.setState(useSocial.getInitialState(), true);
  useUnits.setState(useUnits.getInitialState(), true);
  useWorld.setState(useWorld.getInitialState(), true);
  useBalances.getState().reset();
}

export function hydrateDomains(state: MeState): void {
  useBase.setState({ base: state.base, loading: false, error: null });
  useProgression.getState().hydrate(state.account.id, state.progression);
  useStore.setState({ cosmetics: state.cosmetics, flashCount: state.navigation.store.flash, offerCount: state.navigation.store.offers });
  useEvents.setState({ runs: state.events.runs, modifiers: state.events.modifiers, daily: state.daily, growth: state.growth, attention: claimableCount({ runs: state.events.runs, daily: state.daily, growth: state.growth }) });
  useSocial.setState({ mailUnread: state.navigation.mail, unread: state.navigation.chat.global + state.navigation.chat.dm + state.navigation.mail });
}

/** Discard cached mutable domain data after an epoch/gap; route panels remount and read their active state. */
export function invalidateDomainsAfterRecovery(): void {
  resetCatalogueCache();
  useStore.setState({ view: null, vip: null, lucky: null, shops: null, loading: false, purchasing: null, confirm: null });
  useUnits.setState({ roster: null, banners: null, arena: null, arenaLog: null, expeditions: null, battles: null, training: null });
  useWorld.setState({ me: null, view: null, camp: null, scouts: null, boss: null, attacks: null, loading: false });
  useSocial.setState({ chat: null, mail: null, messages: {}, board: null, neighbours: null, contacts: null, profile: null, profileOptions: null });
  useBase.setState({ research: null });
  useEvents.setState({ calendar: null, achievements: null });
}
